export default __webpack_public_path__ + "static/media/logoBioMedika.9f16a067.svg";